import type { BatchRejectResponse, BatchRejectBody } from "@/core/types";
import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";

export async function batchRejectAction(data: BatchRejectBody): Promise<BatchRejectResponse> {
  return cosignatureRequestsTyped.batch_reject({ data });
}
